<template>
  <table class="Listagem mt-3 mb-4">
    <tr class="Listagem_titulo"
        :class="{ 'Listagem_border_right': edicaoVinculacao }">
      <th v-if="!propReadOnly && !propRadioButton"
          class="Listagem_switch">
        <b-form-checkbox ref="selecionaTodosSelos"
                         v-model="checkBoxSelecionaTodos"
                         class="ml-4 d-flex justify-content-between align-items-center mt-0 mb-4"
                         switch
                         :value="true"
                         :disabled="disabledCheckBoxSelecionaTodos"
                         @change="selecionarTodosCheckbox()"
                         @keyup.native.enter="selecionarTodosCheckbox()" />
      </th>

      <th v-else-if="propRadioButton"
          class="Listagem_radio_button" />

      <th class="Listagem_selo"
          :class="{ 'pl-4': propReadOnly }">
        Selo vinculado
      </th>

      <th class="Listagem_os">
        OS
      </th>

      <th v-if="edicaoVinculacao"
          class="Listagem_data_hora_vinculacao">
        Data/hora vinculação
      </th>

      <th :class="edicaoVinculacao ? 'Listagem_alerta_selo_invalido' : 'Listagem_alerta'" />

      <th v-if="selos.filter(selo => selo.erroVinculacaoTJ).length > 0 || selos.filter(selo => selo.hasOwnProperty('envio_vinculacao_tj') && !selo.envio_vinculacao_tj).length > 0"
          class="Listagem_excluir_vinculacao" />
    </tr>

    <tr v-for="(selo, index) in selos"
        :key="index"
        :class="{ 'Listagem_linha_escura': index % 2 === 0,
                  'Listagem_linha_clara': index % 2 !== 0, 
                  'Listagem_selo_invalido': selo.erroVinculacaoTJ }">
      <td v-if="!propReadOnly && !propRadioButton">
        <b-form-checkbox v-model="selo.check"
                         class="ml-4"
                         switch
                         :value="true"
                         :disabled="selo.disableCheckbox"
                         @change="changeSelosCheckbox(!selo.check, index)"
                         @keyup.native.enter="changeSelosCheckbox(!selo.check, index)" />
      </td>

      <td v-else-if="propRadioButton">
        <b-form-radio :id="`selo_${_uid}_${index}`"
                      :ref="`selo_${_uid}_${index}`"
                      v-model="radioButtonIndexSeloSelected"
                      :name="`selo_${_uid}_${index}`"
                      type="radio"
                      class="mb-4 Listagem_margin_left_radio_button"
                      :value="index"
                      :disabled="selo.disableRadioButton"
                      @change="changeSeloRadio(index)"
                      @keyup.native.enter="changeSeloRadio(index)" />
      </td>

      <td :class="{ 'pl-4': propReadOnly }">
        <div :class="{ 'Listagem_line_through': !!selo.vinculador }">
          {{ selo.num_selo }}
        </div>

        <div :id="`tooltip_selo_${_uid}_${index}`"
             class="Listagem_width_ato_tooltip"
             :class="{ 'Listagem_line_through': !!selo.vinculador }">
          {{ selo.seloItemOs.ordemServicoItem.custa.ato.substring(0, 31) }}

          <label v-if="selo.seloItemOs.ordemServicoItem.custa.ato.length > 31"
                 class="Listagem_margin_reticencias">
            ...
          </label>
        </div>

        <b-tooltip :target="`tooltip_selo_${_uid}_${index}`"
                   placement="bottom"
                   :class="{ 'Listagem_line_through': !!selo.vinculador }">
          {{ selo.seloItemOs.ordemServicoItem.custa.ato }}
        </b-tooltip>
      </td>

      <td>
        <div class="Listagem_padding_bottom"
             :class="{ 'Listagem_line_through': !!selo.vinculador }">
          OS {{ selo.seloItemOs.ordemServicoItem.ordemServico.numero }}
        </div>
      </td>

      <td v-if="edicaoVinculacao"
          class="Listagem_padding_bottom">
        {{ selo.dataVinculacaoFormatada }}
      </td>

      <td>
        <div v-if="selo.vinculador || (selo.vinculacoes && selo.vinculacoes.length > 0)">
          <div v-if="selo.vinculador && selo.nameResumo && selo.resumoId">
            <router-link target="_blank"
                         :title="selo.num_selo"
                         :to="{ name: selo.nameResumo, params: { id: selo.resumoId }, query: { mostrarSelos: true } }">
              <label class="Listagem_vinculado">
                Já vinculado
              </label>
            </router-link>
          </div>

          <div v-else-if="selo.vinculacoes.length > 0"
               class="Listagem_vinculador">
            Selo Vinculador
          </div>
        </div>

        <div v-else-if="selo.erroVinculacaoTJ"
             class="pb-4 Listagem_width_label_selo_invalido">
          <div :id="`tooltip_erro_vinculacao_tj_${_uid}_${index}`">
            <icon-svg icon="alert"
                      class="icon icon--sm icons--black pr-1" />
            Selo inválido
          </div>

          <b-tooltip :target="`tooltip_erro_vinculacao_tj_${_uid}_${index}`"
                     placement="bottom">
            {{ selo.erroVinculacaoTJ.replace(/^.+Erro:/, '') }}
          </b-tooltip>
        </div>
      </td>

      <td v-if="selos.filter(selo => selo.erroVinculacaoTJ).length > 0 || selos.filter(selo => selo.hasOwnProperty('envio_vinculacao_tj') && !selo.envio_vinculacao_tj).length > 0"
          class="Listagem_excluir_vinculacao Listagem_padding_bottom">
        <button v-if="selos.filter(selo => selo.erroVinculacaoTJ).length > 0 || (selo.hasOwnProperty('envio_vinculacao_tj') && !selo.envio_vinculacao_tj)"
                class="btn btn-sm btn-danger"
                @click="$emit('deleteVinculacoes', selo.vinculacao_selo_id)"
                @keyup.enter="$emit('deleteVinculacoes', selo.vinculacao_selo_id)">
          Excluir
        </button>
      </td>
    </tr>
  </table>
</template>

<script>
  export default {
    name: 'ListagemSelos',
    props: {
      propSelos: { type: Array, default: () => ([]) },
      propRegistroId: { type: Number, default: () => null },
      propReadOnly: { type: Boolean, default: () => false },
      propRadioButton: { type: Boolean, default: () => false },
      propFocusSelecionarTodos: { type: Boolean, default: () => false }
    },
    data () {
      return {
        // selos recebidos da prop
        selos: [],

        // controla o checkbox de seleciona todos
        checkBoxSelecionaTodos: false,
        disabledCheckBoxSelecionaTodos: false,

        // controle o index do selo selecionado no radio button
        radioButtonIndexSeloSelected: null,

        // muda a listagem quando for edição
        edicaoVinculacao: false
      }
    },
    watch: {
      propSelos: function (newVal) {
        if (this.propRadioButton) {
          this.selos = newVal

          this.initRadioButton()
          this.changeSeloRadio()
          this.tratarResumoRegistro()
        }
      }
    },
    beforeMount () {
      this.selos = this.propSelos

      this.tratarResumoRegistro()

      // caso a listagem de selo seja pra radio button
      if (this.propRadioButton) {
        this.initRadioButton()
        return
      }

      // filtramos os selos que estão como check
      const selosChecked = this.selos.filter(selo => selo.check)

      // desabilita o checkbox caso os selos não tenha a propriedade disableCheckbox
      if (!this.propReadOnly && !selosChecked.length) {
        this.selos.forEach(selo => {
          if (!selo.hasOwnProperty('disableCheckbox')) {
            selo.disableCheckbox = false
          }

          selo.check = false
        })
      }

      // verificamos se todos os selos estão com disableCheckbox
      if (this.selos.every(selo => selo.disableCheckbox)) {
        this.checkBoxSelecionaTodos = false
        this.disabledCheckBoxSelecionaTodos = true
      }

      if (this.selos.every(selo => !!selo.check)) {
        this.checkBoxSelecionaTodos = true
        this.disabledCheckBoxSelecionaTodos = false
      }

      // caso algum selo tenha data de vinculação formatada mudamos pra listagem pro modo de edição
      this.edicaoVinculacao = !!this.selos.find(selo => selo.dataVinculacaoFormatada)

      if (this.propFocusSelecionarTodos) {
        setTimeout(() => {
          if (this.$refs['selecionaTodosSelos']) {
            this.$refs['selecionaTodosSelos'].focus()
          }
        }, 100)
      }
    },
    methods: {
      initRadioButton () {
        this.radioButtonIndexSeloSelected = null

        setTimeout(() => {
          if (this.$refs[`selo_${this._uid}_0`][0]) {
            this.$refs[`selo_${this._uid}_0`][0].focus()
          }
        }, 100)
      },

      /**
       * Percorremos os selos e verificamos de qual tipo pertence.
       * Adicionamos as informações referentes ao resumo para o router link
       */
      tratarResumoRegistro () {
        for (const selo of this.selos) {
          if (!selo.registro) continue

          if (selo.registro.obito) {
            selo.nameResumo = 'resumo_obito'
            selo.resumoId = selo.registro.obito.obito_id
          }

          if (selo.registro.nascimento) {
            selo.nameResumo = 'resumo_nascimento'
            selo.resumoId = selo.registro.nascimento.nascimento_id
          }

          if (selo.registro.casamento) {
            selo.nameResumo = 'resumo_casamento'
            selo.resumoId = selo.registro.casamento.casamento_id
          }

          if (selo.registro.habilitacaoCasamento) {
            selo.nameResumo = 'resumo_habilitacao_casamento'
            selo.resumoId = selo.registro.habilitacaoCasamento.habilitacao_casamento_id
          }
        }
      },

      selecionarTodosCheckbox () {
        this.checkBoxSelecionaTodos = !this.checkBoxSelecionaTodos

        this.selos.forEach(selo => {
          if (!selo.disableCheckbox) {
            selo.check = this.checkBoxSelecionaTodos
          }
        })

        this.selecionadosCheckbox()
      },

      changeSelosCheckbox (check, index) {
        this.selos[index].check = check

        // Fazemos isso pro vue reconhecer a mudança e atualizar os dados na tela
        this.selos = [...this.selos]

        this.selecionadosCheckbox()
      },

      selecionadosCheckbox () {
        this.$emit('selecionados', {
          registroId: this.propRegistroId,
          selos: this.selos.filter(selo => selo.check && !selo.disableCheckbox)
        })
      },

      changeSeloRadio (index = null) {
        this.radioButtonIndexSeloSelected = index
        this.$emit('indexSeloSelecionado', this.radioButtonIndexSeloSelected)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/scss/_utilities/_exports';

  .Listagem {
    width: 100%;
    font-size: 17.5px;
  
    &_titulo {
      background-color: $water-green-color;
      line-height: 37px;
    }

    &_switch {
      width: 7%;
    }

    &_radio_button {
      width: 7%;
    }

    &_selo {
      width: 35%;
    }

    &_os {
      width: 15%;
    }

    &_data_hora_vinculacao {
      width: 18%;
    }

    &_alerta {
      width: 43%;
    }

    &_alerta_selo_invalido {
      width: 25%
    }

    &_excluir_vinculacao {
      width: 7%;
    }

    &_linha_clara {
      line-height: 35px;
      border-bottom: 1px solid $color-gray;
    }

    &_linha_escura {
      line-height: 35px;
      background-color: #f0ecec;
      border-bottom: 1px solid $color-gray;
    }

    &_padding_bottom {
      padding-bottom: 30px;
    }

    &_vinculado {
      cursor: pointer;
      color: #8b0000;
      width: 100%;
      padding-bottom: 30px;
      text-decoration: underline;
    }

    &_vinculador {
      color: #086AAE;
      width: 100%;
      padding-bottom: 30px;
    }

    &_margin_reticencias {
      margin-left: -3px;
    }

    &_margin_left_radio_button {
      margin-left: 30px;
    }

    &_selo_invalido {
      border: 1px solid #8b0000;
    }

    &_width_label_selo_invalido {
      width: 100%;
      display: inline-flex;
      justify-content: center;
    }

    &_width_ato_tooltip {
      //width: 70%;
    }

    &_border_right {
      border-right: 1px solid $water-green-color;
    }

    &_line_through {
      text-decoration: line-through;
    }
  }
</style>
